import { t } from "@lingui/core/macro";
import { atom } from "jotai";

import { PackagesList_customer$key } from "../PackagesList/components/__generated__/PackagesList_customer.graphql";
import { PackageType } from "./components/__generated__/ModalLoaderQuery.graphql";
import { ModalState } from "./types";

export const CurrentPackagesModalAtom = atom<ModalState>({ page: "loading" });

export const currentPageAtom = atom(
  (get) => get(CurrentPackagesModalAtom).page
);

export const onBackAtom = atom((get) => get(CurrentPackagesModalAtom).onBack);

export const packageListFragmentAtom = atom<PackagesList_customer$key | null>(
  (get) => {
    const state = get(CurrentPackagesModalAtom);
    if (state.page === "list") {
      return state.customerRef;
    } else {
      return null;
    }
  }
);

export const currentPackageIdAtom = atom((get) => {
  const state = get(CurrentPackagesModalAtom);
  if (state.page === "detail") {
    return state.packageId;
  } else {
    return null;
  }
});

export const goToListPageAtom = atom(
  null,
  (
    _get,
    set,
    {
      customerRef,
      type,
    }: { customerRef: PackagesList_customer$key | null; type: PackageType }
  ) => {
    set(CurrentPackagesModalAtom, {
      page: "list",
      customerRef,
      type,
      onBack: undefined,
    });
  }
);

export const goToDetailPageAtom = atom(
  null,
  (
    _get,
    set,
    {
      packageId,
      packageName,
      onBack,
    }: { packageId: string; packageName: string; onBack: () => void }
  ) => {
    set(CurrentPackagesModalAtom, {
      page: "detail",
      packageId,
      packageName,
      onBack,
    });
  }
);

export const goToOrderPageAtom = atom(
  null,
  (
    _get,
    set,
    {
      orderId,
      packageId,
      onBack,
    }: { orderId: string; packageId: string; onBack: () => void }
  ) => {
    set(CurrentPackagesModalAtom, {
      page: "order",
      orderId,
      packageId,
      onBack,
    });
  }
);

export const modalTitleAtom = atom<string | undefined>((get) => {
  const state = get(CurrentPackagesModalAtom);
  switch (state.page) {
    case "list":
      return state.type === "STANDARD" ? t`Packages` : t`Memberships`;
    case "detail":
      return state.packageName;
    case "order":
      return t`Outstanding Order`;
    default:
      return undefined;
  }
});

export const modalShowSubTitleAtom = atom<boolean>((get) => {
  const state = get(CurrentPackagesModalAtom);
  return state.page === "list";
});
